export default class Nav {

    /**
     * constructor
     *
     * @param  {Router} router
     */
    constructor (router) {
        this.elements = Array.from(document.querySelectorAll('.js-nav'));
        this.navContainer = document.querySelector('[data-nav-toggle="container"]');
        this.router = router;

        this.bindEvents();
    }


    /**
     * Bind click events to nav elements, and let the router handle them
     */
    bindEvents () {
        this.elements.forEach((nav) => {
            nav.addEventListener('click', (e) => {
                e.preventDefault();

                this.router.navigate(e.target.href);
                this.navContainer.classList.remove('is-active');
                document.body.classList.remove('is-inactive');
            });
        });
    }
}



// WEBPACK FOOTER //
// ./lib/nav.js